import { AuthenticationType } from '../Enums/authentication-type';

export class RestApiAuthenticationConfiguration {
    public authenticationType: AuthenticationType;
    public username: string;
    public password: string;
    public apiKey: string;
    public bearer: string;

    /**
     * Retourne une copie d'une instance de RestApiAuthenticationConfiguration
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: RestApiAuthenticationConfiguration) {
        if (!!other) {
            const instance = new RestApiAuthenticationConfiguration();

            instance.authenticationType = other.authenticationType;
            instance.username = other.username;
            instance.password = other.password;
            instance.apiKey = other.apiKey;
            instance.bearer = other.bearer;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de RestApiAuthenticationConfiguration
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: RestApiAuthenticationConfiguration[]) {
        if (!!others) {
            let authentications: RestApiAuthenticationConfiguration[] = [];

            others.forEach((x) => {
                const authentication = RestApiAuthenticationConfiguration.clone(x);
                authentications.push(authentication);
            });

            return authentications;
        } else {
            return [];
        }
    }
}
